function decodeTokenPayload(token) {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export function useIsHQ() {
  const token = localStorage.getItem('token');
  if (!token) return false;
  const payload = decodeTokenPayload(token);
  return payload?.role === 'headquarters';
}

export function useRole() {
  const token = localStorage.getItem('token');
  if (!token) return 'standard';
  const payload = decodeTokenPayload(token);
  return payload?.role || 'standard';
}

export function useIdentity() {
  const token = localStorage.getItem('token');
  if (!token) return { id: null, email: null, role: 'standard' };
  const payload = decodeTokenPayload(token);
  return { id: payload?.id ?? null, email: payload?.email ?? null, role: payload?.role || 'standard' };
}
